<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card-title>
          <v-row align="center" style="justify-content: right;margin-top: -110px;width:100%">
            <v-col class="pt-5" cols="12" xs="12" md="2">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.cc"
                :items="CC"
                item-value="id"
                :item-text="item => item.firstName + ' ' + item.lastName"
                clearable
                outlined
                dense
                hide-details="auto"
                label="CC"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mt-0" style="width:100%;">
            <v-col class="pt-0" cols="12" xs="12" md="12">
              <v-layout row wrap class="mt-0">
                <v-flex md4 sm6 xs12 pa-3>
                  <v-card class="small-box" dark color="#363636" min-height="145px">
                    <v-card-title class="title card-title one-line">Pending</v-card-title>
                    <v-card-text>
                      <h3>{{totalValues.pending}}</h3>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex md4 sm6 xs12 pa-3>
                  <v-card class="small-box" dark color="#363636" min-height="145px">
                    <v-card-title class="title card-title one-line">Valid</v-card-title>
                    <v-card-text>
                      <h3>{{totalValues.verified}}</h3>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex md4 sm6 xs12 pa-3>
                  <v-card class="small-box" dark color="#363636" min-height="145px">
                    <v-card-title class="title card-title one-line">Invalid</v-card-title>
                    <v-card-text>
                      <h3>{{totalValues.unverified}}</h3>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>
          <div style="display: flex; align-items: center; justify-content: flex-end; width: 100%; padding-top: 12px; gap: 12px;">
            <!-- <div style="padding-top: 12px;">
              <v-checkbox
                class="mt-0 pr-4"
                v-model="filters.starOnly"
                label="Star Only"
                color="secondary"
                :value="false"
                hide-details
                @change="searchFilter()"
              ></v-checkbox>
            </div> -->
            <!-- <div style="padding-top: 12px;">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.subCategory"
                :items="rateCardLabels"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Sub Category"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </div> -->
            <div style="padding-top: 12px;">
              <v-menu
                offset-y
                bottom
                transition="scale-transition"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                  >
                    TikTok Followers <v-icon right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-list min-height="100px">
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        From
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="rateCardConfig.followerOptions.from"
                          v-model="filters.tiktokFollowers.from"
                          style="max-width:120px;" 
                        ></v-combobox>
                      </v-col>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        To
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="rateCardConfig.followerOptions.to"
                          v-model="filters.tiktokFollowers.to"
                          style="max-width:120px;"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        <v-checkbox
                          class="mt-0"
                          v-model="filters.isTikTokEmpty"
                          label="Empty"
                          color="secondary"
                          value="orange"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                
                <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
                  <v-list-item style="float:right">
                    <v-btn color="secondary" small @click.stop="searchTikTokFollower()">
                      Apply
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div style="padding-top: 12px;">
              <v-menu
                offset-y
                bottom
                transition="scale-transition"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                  >
                    IG Followers <v-icon right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-list min-height="100px">
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        From
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="rateCardConfig.followerOptions.from"
                          v-model="filters.followers.from"
                          style="max-width:120px;" 
                        ></v-combobox>
                      </v-col>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        To
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="rateCardConfig.followerOptions.to"
                          v-model="filters.followers.to"
                          style="max-width:120px;"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        <v-checkbox
                          class="mt-0"
                          v-model="filters.isIgEmpty"
                          label="Empty"
                          color="secondary"
                          value="orange"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                
                <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
                  <v-list-item style="float:right">
                    <v-btn color="secondary" small @click.stop="searchIGFollower()">
                      Apply
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div style="padding-top: 12px;">
              <v-menu
                offset-y
                bottom
                transition="scale-transition"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                  >
                    Rate <v-icon right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-list min-height="100px">
                  <v-list-item class="mb-2">
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        Content Type
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="contentTypes"
                          item-text="title"
                          item-value="value"
                          v-model="filters.contentType"
                          style="max-width:100%;"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="mb-2">
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        Currency
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="currencyOptions"
                          v-model="filters.rateCurrency"
                          style="max-width:100%;"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="mb-2">
                    <v-row>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        From
                        <v-text-field
                          outlined
                          dense        
                          clearable
                          type="number"
                          hide-details="auto"
                          v-model="filters.rate.from"
                          style="max-width:120px;" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        To
                        <v-text-field
                          outlined
                          dense        
                          clearable
                          type="number"
                          hide-details="auto"
                          v-model="filters.rate.to"
                          style="max-width:120px;" 
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                
                <v-list min-height="100px" style="min-height:60px;">
                  <v-list-item style="float:right">
                    <v-btn color="secondary" small @click.stop="searchFilter()">
                      Apply
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div style="padding-top: 12px;">
              <v-menu
                offset-y
                bottom
                transition="scale-transition"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                  >
                    Age <v-icon right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-list min-height="100px">
                  <v-list-item class="mb-2">
                    <v-row>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        Min Age
                        <v-text-field
                          outlined
                          dense        
                          clearable
                          type="number"
                          hide-details="auto"
                          v-model="filters.age.min"
                          style="max-width:120px;" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        Max Age
                        <v-text-field
                          outlined
                          dense        
                          clearable
                          type="number"
                          hide-details="auto"
                          v-model="filters.age.max"
                          style="max-width:120px;" 
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                
                <v-list min-height="100px" style="min-height:60px;">
                  <v-list-item style="float:right">
                    <v-btn color="secondary" small @click.stop="searchFilter()">
                      Apply
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div style="padding-top: 12px;">
              <v-autocomplete
                style="max-width:200px"
                v-model="filters.country"
                :items="countries"
                item-value="value"
                item-text="text"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Country"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </div>
            <!-- <div style="padding-top: 12px;">
              <v-menu
                ref="DOBDatePicker"
                v-model="dateOfBirthCal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                dense
                max-width="350px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="Date of Birth"
                    placeholder="Date of Birth"
                    v-model="filters.dateOfBirth"
                    @change="searchFilter"
                    dense
                    readonly
                    outlined
                    clearable
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.dateOfBirth"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="secondary"
                      @click="cancelDOB()"
                  >
                      Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="secondary"
                      @click="searchFilter"
                  >
                      OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div> -->
            <!-- <div style="padding-top: 12px;">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.category"
                :items="categories"
                item-value="value"
                item-text="text"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Preferred Campaigns/Genre"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </div> -->
            <!-- <div style="padding-top: 12px;">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.cc"
                :items="CC"
                item-value="id"
                :item-text="item => item.firstName + ' ' + item.lastName"
                clearable
                outlined
                dense
                hide-details="auto"
                label="CC"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </div> -->
            <!-- <div style="padding-top: 12px;">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.subCategory"
                :items="rateCardLabels"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Sub Category"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </div> -->
            <div style="padding-top: 12px;">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.mainCategory"
                :items="rateCardLabels"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Main Category"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </div>
            <div style="padding-top: 12px;">
              <v-select
                style="max-width:200px"
                v-model="filters.status"
                :items="statuses"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Status"
                @change="searchFilter"                    
              >
              </v-select>
            </div>
          </div>
          <v-row class="mt-0" align="center" style="width:100%;justify-content: right">
            <v-col class="pt-5" cols="12" xs="12" md="2">
              <v-text-field style="max-width:300px" v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-col>
            <v-col style="max-width:50px;" class="pt-5 pa-0" cols="12" xs="12" md="2">
              <v-menu
                bottom
                transition="scale-transition"
                :close-on-content-click="false"
                style="margin-left:-25px;"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    <v-icon>mdi-sort</v-icon>
                  </v-btn>
                </template>
                <v-list style="max-width:230px" min-height="100px">
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        Sort By
                        <v-select
                          outlined
                          dense
                          clearable
                          hide-details="auto"
                          :items="sortColumns"
                          v-model="sort.column"
                          style="max-width:200px;" 
                        ></v-select>
                      </v-col>
                      <v-col cols="12" xs="12" md="12" lg="12" v-if="isSortCurrency">
                        Currency
                        <v-select
                          outlined
                          dense
                          clearable
                          hide-details="auto"
                          :items="currencyOptions"
                          v-model="sort.currency"
                          style="max-width:200px;"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        Type
                        <v-select
                          outlined
                          dense
                          hide-details="auto"
                          :items="sortTypes"
                          v-model="sort.type"
                          style="max-width:200px;" 
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                <v-list min-height="100px" style="min-height:60px;margin-top:-20px">
                  <v-list-item style="float:right">
                    <v-btn color="secondary" small @click.stop="searchFilter()">
                      Apply
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col style="max-width:50px;" class="pt-5 pa-0" cols="12" xs="12" md="2">
              <v-menu
                :close-on-content-click="false"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal"
                  >
                    <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                  </v-btn>
                </template>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-title>
        <!-- BEGIN vue data table -->
        <v-data-table
        id="rate-card-data-table"
        :headers="computedHeaders" 
        :search="filter" 
        :items="filteredItems" 
        class="elevation-1">
          <template v-slot:[`item.name`]="{ item }">
            <td class="text-left">
              {{item.name}}
            </td>
          </template>
          <template v-slot:[`item.email`]="{ item }">
            <td class="text-left">
              {{item.email}}
            </td>
          </template>
          <template v-slot:[`item.dateOfBirth`]="{ item }">
            <td class="text-left" style="min-width:120px!important">
              {{item.dateOfBirth ? utils.formatCustomDate(item.dateOfBirth, 'MMM, YYYY') : ''}}
            </td>
          </template>
          <template v-slot:[`item.ethnicity`]="{ item }">
            <td class="text-left">
              {{item.ethnicity && item.ethnicity !== 'Others' ? item.ethnicity : ''}}
              {{item.otherEth ? item.otherEth : ''}}
            </td>
          </template>
          <template v-slot:[`item.country`]="{ item }">
            <td class="text-left">
              {{item.country}}
            </td>
          </template>
          <template v-slot:[`item.city`]="{ item }">
            <td class="text-left">
              {{item.city}}
            </td>
          </template>
          <template v-slot:[`item.gender`]="{ item }">
            <td class="text-left">
              {{item.gender}}
            </td>
          </template>
          <template v-slot:[`item.contactNo`]="{ item }">
            <td class="text-left">
              {{item.contactNo}}
            </td>
          </template>
          <template v-slot:[`item.instagramHandle`]="{ item }">
            <td class="text-left">
              <social-handle
                :isInstagram="true"
                :instagramHandle="item.instagramHandle"
                v-if="item.instagramHandle"
              />
            </td>
          </template>
          <template v-slot:[`item.igFollowerCount`]="{ item }">
            <td class="text-left">
              {{item.igFollowerCount | thousandSeprator}}
            </td>
          </template>
          <template v-slot:[`item.tiktokHandle`]="{ item }">
            <td class="text-left">
              <social-handle
                :isTikTok="true"
                :tiktokHandle="item.tiktokHandle"
                v-if="item.tiktokHandle"
              />
            </td>
          </template>
          <template v-slot:[`item.tiktokFollowerCount`]="{ item }">
            <td class="text-left">
              {{item.tiktokFollowerCount | thousandSeprator}}
            </td>
          </template>
          <template v-slot:[`item.cc`]="{ item }">
            <td class="text-left">
              <span v-if="item.sourceID">
                {{ CC.find(cc => cc.id === item.sourceID) ? CC.find(cc => cc.id === item.sourceID).firstName + ' ' + CC.find(cc => cc.id === item.sourceID).lastName : '' }}
              </span>
            </td>
          </template>
          <template v-slot:[`item.youtube`]="{ item }">
            <td class="text-left" style="max-width:120px">
              <div v-if="getPlatformUrl(item, 'youtube')">
                <a :href="getPlatformUrl(item, 'youtube')" target="_blank" style="line-break:anywhere"><v-icon>mdi-youtube</v-icon> {{getHandlePreview(item, 'youtube')}}</a>
              </div>
            </td>
          </template>
          <template v-slot:[`item.facebook`]="{ item }">
            <td class="text-left" style="max-width:120px">
              <div v-if="getPlatformUrl(item, 'facebook')">
                <a :href="getPlatformUrl(item, 'facebook')" target="_blank" style="line-break:anywhere"><v-icon>mdi-facebook</v-icon> {{getHandlePreview(item, 'facebook')}}</a>
              </div>
            </td>
          </template>
          <template v-slot:[`item.twitch`]="{ item }">
            <td class="text-left" style="max-width:120px">
              <div v-if="getPlatformUrl(item, 'twitch')">
                <a :href="getPlatformUrl(item, 'twitch')" target="_blank" style="line-break:anywhere">{{getHandlePreview(item, 'twitch')}}</a>
              </div>
            </td>
          </template>
          <template v-slot:[`item.igStory`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igStoryCurrency}} {{item.ordinaryRates.igStory | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igPost`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igPostCurrency}} {{item.ordinaryRates.igPost | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igCarousel`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igCarouselCurrency}} {{item.ordinaryRates.igCarousel | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igVideo`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igVideoCurrency}} {{item.ordinaryRates.igVideo | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igReel`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igReelCurrency}} {{item.ordinaryRates.igReel | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igRemarks`]="{ item }">
            <td class="text-left" style="min-width:120px!important">
              <v-tooltip bottom max-width="300px">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <p class="remark-text">{{item.igRemarks || '-'}}</p>
                  </div>
                </template>
                <span v-html="formatDesc(item.igRemarks)"></span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:[`item.tiktok`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.tiktokCurrency}} {{item.ordinaryRates.tiktok | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.tiktokRemarks`]="{ item }">
            <td class="text-left" style="min-width:120px!important">
              <v-tooltip bottom max-width="300px">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <p class="remark-text">{{item.tiktokRemarks || '-'}}</p>
                  </div>
                </template>
                <span v-html="formatDesc(item.tiktokRemarks)"></span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:[`item.eventAppearance`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.eventAppearanceCurrency}} {{item.ordinaryRates.eventAppearance | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.loadingFee`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.loadingFeeCurrency}} {{item.ordinaryRates.loadingFee | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.uploadMediaKit`]="{ item }">
            <td class="text-left">
              <v-btn
                small
                text
                color="secondary"
                v-for="(deck, idx) in item.pricingDecks"
                :key="idx"
                :href="deck.url"
                target="_blank"
              >
                View Media
              </v-btn>
            </td>
          </template>
          <template v-slot:[`item.preferredCampaigns`]="{ item }">
            <td class="text-left">
              <v-chip
                v-if="!item.keywords || item.keywords.length === 0"
                class="ma-2"
                color="#ffffff"
                x-small
                text-color="black"
                style="text-transform: capitalize;"
              >{{'-'}}</v-chip>
              <v-chip                                 
                v-else                              
                v-for="(keyword, index) in item.keywords"
                :key="index"
                v-show="index === 0"
                class="ma-2"
                x-small             
              >{{keyword}}</v-chip> 
              <v-menu                                                            
                v-show="item.keywords"      
                :close-on-content-click="false"    
                top                                                 
                offset-x                              
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :id="'btnMore_'+item.id"
                    v-show="item.keywords && item.keywords.length > 1"                       
                    color="secondary"
                    x-small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    More...
                  </v-btn>
                </template>
                <v-card max-width="300" style="text-align: left;">
                  <v-card-text>
                    <div>Preferred Campaigns / Genre</div>
                    <v-divider></v-divider>                                    
                    <v-chip                                      
                      v-for="(interest, index) in item.keywords"
                      :key="index"
                      v-show="index !== 0"
                      class="ma-2"
                      small           
                    >{{interest}}</v-chip>
                  </v-card-text>
                </v-card>
              </v-menu>
            </td>
          </template>
          <!-- <template v-slot:[`item.labelDisplays`]="{ item }">
            <td class="text-left">
              <v-chip
                v-if="!item.mainCategories || item.mainCategories.length === 0"
                class="ma-2"
                color="#ffffff"
                x-small
                text-color="black"
                style="text-transform: capitalize;"
              >{{'-'}}</v-chip>
              <v-chip                                 
                v-else      
                class="ma-2"
                x-small             
              >{{item.mainCategories}}</v-chip> 
              <v-menu                                                            
                v-show="item.mainCategories"      
                :close-on-content-click="false"    
                top                                                 
                offset-x                              
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :id="'btnMore_'+item.id"
                    v-show="item.mainCategories && item.mainCategories.length > 0"
                    color="secondary"
                    x-small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    More...
                  </v-btn>
                </template>
                <v-card max-width="300" style="text-align: left;">
                  <div>
                    <v-card-text>
                      <div class="font-weight-bold">Main Category</div>
                      <v-divider></v-divider>                                    
                      <v-chip                                      
                        class="ma-2"
                        small           
                      >{{item.mainCategories}}</v-chip>
                    </v-card-text>
                    <v-card-text>
                      <div class="font-weight-bold">Sub Category</div>
                      <v-divider></v-divider>                                    
                      <v-chip                                      
                        v-for="(sub, index) in item.subCategories"
                        :key="index"
                        class="ma-2"
                        small           
                      >{{sub}}</v-chip>
                    </v-card-text>
                  </div>
                </v-card>
              </v-menu>
            </td>
          </template> -->
         <template v-slot:[`item.labels`]="{ item }">
            <td class="text-left">
               <v-chip
                v-if="!item.labels || item.labels.length === 0"
                class="ma-2"
                color="#ffffff"
                x-small
                text-color="black"
                style="text-transform: capitalize;"
              >{{'-'}}</v-chip>
              <v-chip                                 
                v-else                              
                v-for="(keyword, index) in item.labels"
                :key="index"
                v-show="index === 0"
                class="ma-2"
                x-small             
              >{{keyword}}</v-chip> 
              <v-menu                                                            
                v-show="item.labels"      
                :close-on-content-click="false"    
                top                                                 
                offset-x                              
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :id="'btnMore_'+item.id"
                    v-show="item.labels && item.labels.length > 0"
                    color="secondary"
                    x-small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    More...
                  </v-btn>
                </template>
                <v-card max-width="300" style="text-align: left;">
                  <v-card-text>
                    <div class="font-weight-bold">Labellings</div>
                    <v-divider></v-divider>                                    
                    <v-chip                                      
                      v-for="(label, index) in item.labels"
                      :key="index"
                      v-show="index !== 0"
                      class="ma-2"
                      small           
                    >{{label}}</v-chip>
                  </v-card-text>
                </v-card>
              </v-menu>
              <!-- Add Labels -->
              <v-menu                     
                :close-on-content-click="false"    
                top                                                 
                offset-x                              
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mb-1 pa-0"           
                    color="secondary"
                    small
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    <v-icon small>edit</v-icon>  Label
                  </v-btn>
                </template>
                <v-card max-width="300" style="text-align: left;">
                  <div>
                    <v-card-text>
                      <div class="font-weight-bold">Main Category</div>
                      <v-divider style="margin-bottom:0"></v-divider>
                      <v-chip-group
                      active-class="primary--text"
                      v-model="item.mainCategories"
                      column
                      required
                      @change="changeLabel(item)">                                    
                        <v-chip                                      
                          v-for="(label, index) in rateCardLabels"
                          :key="index"
                          :value="label"
                          class="ma-2"
                          small           
                        >{{label}}</v-chip>
                      </v-chip-group>
                    </v-card-text>
                    <v-card-text>
                      <div class="font-weight-bold">Sub Category</div>
                      <v-divider style="margin-bottom:0"></v-divider>
                      <v-chip-group
                      multiple
                      active-class="primary--text"
                      v-model="item.subCategories"
                      column
                      required
                      @change="changeLabel(item)">                                    
                        <v-chip                                      
                          v-for="(label, index) in rateCardLabels"
                          :key="index"
                          :value="label"
                          class="ma-2"
                          small           
                        >{{label}}</v-chip>
                      </v-chip-group>
                    </v-card-text>
                  </div>
                </v-card>
              </v-menu>
            </td>
          </template>
          <template v-slot:[`item.aboutYou`]="{ item }">
            <td class="text-left">
              <v-tooltip bottom max-width="300px">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <p class="remark-text">{{item.aboutYou || '-'}}</p>
                  </div>
                </template>
                <span v-html="formatDesc(item.aboutYou)"></span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:[`item.loadContent`]="{ item }">
            <td class="text-left">
              {{item.loadContent}}
              {{item.loadContentText}}
            </td>
          </template>
          <template v-slot:[`item.giftBrand`]="{ item }">
            <td class="text-left">
              {{item.giftBrand}}
            </td>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <td class="text-left">
              <v-chip
                v-if="item.verify === true"
                color="primary"
                text-color="white"
                small
              >
                Valid
              </v-chip>
              <v-chip
                v-else-if="item.verify === false"
                color="error"
                text-color="white"
                small
              >
                Invalid
              </v-chip>
              <v-chip
                v-else
                color="secondary"
                text-color="white"
                small
              >
                Pending
              </v-chip>
            </td>
          </template>
          <!-- <template v-slot:[`item.engagement`]="{ item }">
            <td class="text-left">
              <span v-if="item.engagement">{{item.engagement | thousandSeprator}}</span>
            </td>
          </template>
          
          <template v-slot:[`item.views`]="{ item }">
            <td class="text-left">
              <span v-if="item.views">{{item.views | thousandSeprator}}</span>
            </td>
          </template> -->
          <template v-slot:[`item.updatedAt`]="{ item }">
            <td class="text-left" style="min-width: 105px!important;">
              {{utils.formatCustomDate(item.updatedAt, 'DD-MM-YYYY') }}
            </td>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <td class="text-left">
              <!-- Star Button -->
              <!-- <v-btn
                data-toggle="tooltip" data-placement="top" title="Unstar"
                class="mt-2"
                icon
                small
                color="secondary"
                v-bind="attrs"
                v-on="on"
                text
                @click="chgStarStatus(item, false)"
                v-if="item.star"
              >
                <v-icon>mdi-star</v-icon>
              </v-btn>
              <v-btn
                data-toggle="tooltip" data-placement="top" title="Star"
                class="mt-2"
                icon
                small
                color="secondary"
                v-bind="attrs"
                v-on="on"
                text
                @click="chgStarStatus(item, true)"
                v-else
              >
                <v-icon>mdi-star-outline</v-icon>
              </v-btn> -->
              <div style="display: flex; gap: 5px;">
                <!-- View Button -->
                <v-btn @click="getDataToView(item)" class="mt-2" color="secondary" icon small text>
                  <v-icon color="secondary" data-toggle="tooltip" data-placement="top" title="View Details">remove_red_eye</v-icon>
                </v-btn>
                <!-- Verify Button -->
                <v-btn @click="openVerifyDialog(item)" class="mt-2" color="success" icon small text>
                  <v-icon color="success" data-toggle="tooltip" data-placement="top" title="Verify">mdi-check-circle</v-icon>
                </v-btn>
                <!-- Reset Password Button -->
                <v-btn
                  @click="openResetDialog(item)"
                  color="secondary"
                  class="mt-2"
                  icon
                  small
                  text
                  :disabled="item.accountExist"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        color="secondary"
                      >mdi-account-plus</v-icon>
                    </template>
                    <span>Onboard to IMS</span>
                  </v-tooltip>
                </v-btn>
                <!-- Delete Button -->
                <v-btn
                  class="mt-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Delete Rate Card"
                  @click="deleteRateCard(item.id)"
                  color="error"
                  text
                  icon
                  small
                  v-if="isAdmin"
                >
                  <v-icon color="danger">delete</v-icon>
                </v-btn>
              </div>
            </td>
          </template>
          <template v-slot:no-data>No Data</template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- View Rate Card modal -->
    <view-modal-dialog
    v-model="viewDialog"
    :value="viewDialog"
    :data="viewData"
    v-if="viewData"/>
    <!-- Verification Checklist Dialog -->
    <verify-dialog
      v-model="verifyDialog"
      :item="verifyData"
      @verified="handleVerified"
    />
    <!-- Table Cols Show Hide Modal -->
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="Ratecard Forms"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <!-- inf user password reset modal -->
    <inf-onboard-password-modal
      :influencer="viewData"
      v-model="infPassResetDialog"
      @reload="onBoardSuccess"
    />
    <!-- loading -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex';
import utils from '@/utils'
import ViewModalDialog from './ViewModalDialog';
import VerifyDialog from './VerifyDialog';
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import InfOnboardPasswordModal from './InfOnboardPasswordModal.vue';
import userAPIs from '../../User/userAPIs';
import config from '@/config';
import rateCardConfig from './config';
import orderBy from 'lodash/orderBy';
import influencerHelper from '../influencerHelper'
import influencerAPIs from '../influencerAPIs';
import countries from '../../../../../static/sources/countries';
import Loading from 'vue-loading-overlay';
// import moment from 'moment';
export default {
  name: 'RateCardDataTable',
  components: {
    ViewModalDialog,
    VerifyDialog,
    SocialHandle,
    TableColsShowHideModal,
    InfOnboardPasswordModal,
    Loading
  },
  props: [
    'reload',
    'isDownload'
  ],
  watch: {
    reload(value) {
      if (value) {
        this.resetFilters()
        this.getRateCardLists()
      }
    },
    isDownload(value) {
      if (value) {
        this.downloadCreatorCommunityRpt()
      }
    }
  },
  computed: {
    ...mapState({
      items: state => state.influencer.creatorCommunities,
      savedCreatorCommunity: state => state.influencer.savedCreatorCommunity
    }),
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    isAdmin: function() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    },
    isSortCurrency() {
      let sortCol = this.sort.column
      return sortCol === 'IG Story' || sortCol === 'IG Post' ||
      sortCol === 'IG Carousel' || sortCol === 'IG Reel' || sortCol === 'Loading Fee' ||
      sortCol === 'Event Attendance' || sortCol === 'TikTok'
    },
    computedHeaders() {
      let creatorCommunityCols = null
      let headers = utils.func.refreshJSON(this.headers)
      headers = headers.map(h => {
        if (h.value === 'labels') {
          h.text = ''
        }
        return h
      })
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.creatorCommunityCols) {
          creatorCommunityCols = Object.assign({}, this.userProfile.tableSettings.creatorCommunityCols)
        }
      }
      if (creatorCommunityCols) {
        this.colStatuses = Object.assign({}, creatorCommunityCols)
      } else {
        // default true if no col status in local storage
        headers.map(header => {
          this.colStatuses[header.value] = true
        })
      }
      return headers.filter(h => {
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      });
    }
  },
  data() {
    return {
      utils: utils.func,
      viewData: null,
      viewDialog: false,
      verifyDialog: false,
      verifyData: null,
      infPassResetDialog: false,
      selectedInfluencerID: '',
      rateCardConfig,
      headers: rateCardConfig.tableHeaders,
      rateCardLabels: rateCardConfig.rateCardLabels,
      filteredItems: [],
      exportItems: [],
      filter: '',
      colStatuses: {},
      CC: [],
      colSettingsDialog: false,
      dateOfBirthCal: false,
      tableColsItems: [],
      userProfile: {},
      categories: influencerHelper.getCategories('en'),
      currencyOptions: rateCardConfig.currencyOptions,
      contentTypes: [
        { title: 'IG Story', value: 'igStory' },
        { title: 'IG Post', value: 'igPost' },
        { title: 'IG Carousel', value: 'igCarousel' },
        { title: 'IG Video', value: 'igVideo' },
        { title: 'IG Reel', value: 'igReel' },
        { title: 'IG TV', value: 'igTv' },
        { title: 'Loading Fee', value: 'loadingFee' },
        { title: 'Event Appearance', value: 'eventAppearance' },
        { title: 'TikTok', value: 'tiktok' }
      ],
      sortColumns: [
        'IG followers',
        'TikTok followers',
        'Date of Birth',
        'Last Updated',
        'IG Story',
        'IG Post',
        'IG Carousel',
        'IG Reel',
        'Loading Fee',
        'Event Attendance',
        'TikTok'
      ],
      sortTypes: [
        'Ascending',
        'Descending'
      ],
      statuses: ['Pending', 'Valid', 'Invalid'],
      sort: {
        column: 'Updated At',
        currency: '',
        type: 'Ascending'
      },
      filters: {
        country: '',
        category: '',
        mainCategory: '',
        subCategory: '',
        cc: '',
        status: '',
        followers: {from: '', to: ''},
        tiktokFollowers: {from: '', to: ''},
        contentType: '',
        rateCurrency: '',
        rate: {from: '', to: ''},
        age: {min: '', max: ''},
        isTikTokEmpty: false,
        isIgEmpty: false,
        starOnly: false
      },
      totalValues: {
        pending: '',
        verified: '',
        unverified: ''
      }
    }
  },
  async mounted() {
    // Retrieve countries manually
    this.countries = countries
    this.countries = this.countries.map(c => c.name)
    // get rate card lists
    await this.getRateCardLists()
    if (this.$route.query.id) {
      let matchItem = this.filteredItems.find(item => item.id === this.$route.query.id)
      this.getDataToView(matchItem)
    }
    await this.getUserProfile()
    // Get CC users
    let resp = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
    if (resp) this.CC = resp.users
  },
  methods: {
    getDataToView(item) {
      this.$router.push({
        path: '/influencers/join-community',
        query: {
          id: item.id
        }
      })
      this.viewData = item
      this.viewDialog = true
    },
    async getRateCardLists() {
      await this.$store.dispatch('influencer/getCreatorCommunityLists')
      let items = this.items.map(i => {
        return i
      })
      items = items.map(item => {
        if (!item.preferentialRates) { item.preferentialRates = {} }
        if (!item.ordinaryRates) {
          item.ordinaryRates = {
            igStory: item.igStory || 0,
            igStoryCurrency: 'SGD',
            igPost: item.igPost || 0,
            igPostCurrency: 'SGD',
            igCarousel: item.igCarousel || 0,
            igCarouselCurrency: 'SGD',
            igVideo: item.igVideo || 0,
            igVideoCurrency: 'SGD',
            igReel: item.igReel || 0,
            igReelCurrency: 'SGD',
            igTv: item.igTv || 0,
            igTvCurrency: 'SGD',
            loadingFee: item.loadingFee || 0,
            loadingFeeCurrency: 'SGD',
            eventAppearance: item.eventAppearance || 0,
            eventAppearanceCurrency: 'SGD',
            tiktok: item.tiktok || 0,
            tiktokCurrency: 'SGD'
          }
        }
        if (!item.keywords) item.keywords = []
        if (!item.mainCategories) item.mainCategories = []
        if (!item.subCategories) item.subCategories = []
        return item
      })
      this.filteredItems = Object.assign([], items)
      this.searchFilter()
    },
    getPlatformUrl(item, platform) {
      if (item.platforms) {
        if (Array.isArray(item.platforms)) {
          let matchYoutube = item.platforms.find(p => p.platform === platform)
          if (matchYoutube) {
            return matchYoutube.url
          }
        }
      }
      return ''
    },
    getHandlePreview(item, platform) {
      let url = this.getPlatformUrl(item, platform)
      let result = url
      if (!url.includes('watch?')) {
        let lastSlashIndex = url.lastIndexOf('/');
        result = url.substring(lastSlashIndex + 1);
      }
      return result
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.headers.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.headers)) {
        if (value.text) {
          this.tableColsItems.push({
            title: value.text,
            key: value.value,
            value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
          })
        }
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      let tableSettings = {}
      if (this.userProfile.tableSettings) {
        tableSettings = this.userProfile.tableSettings
      }
      tableSettings.creatorCommunityCols = Object.assign({}, columns)
      let updateData = {
        id: this.currentUserID,
        tableSettings
      }
      await userAPIs.editUser(updateData)
      // localStorage.setItem('MasterListCols', JSON.stringify(columns))
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    },
    async getUserProfile() {
      let resp = await userAPIs.getUser(this.currentUserID)
      if (resp && resp.id) {
        this.userProfile = resp
      }
    },
    async downloadCreatorCommunityRpt() {
      this.isLoading = true
      let creatorCommunityIds = this.filteredItems.map(i => i.id)
      let data = {
        creatorCommunityIds
      }
      influencerAPIs
        .downloadCreatorCommunityRpt(data)
        .then(() => {
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log('error in downloading creator community report', error);
        });
    },
    searchFilter() {
      this.filteredItems = Object.assign([], this.items)
      if (this.filters.country) {
        this.filteredItems = this.filteredItems.filter(f => f.country === this.filters.country)
      }
      if (this.filters.category) {
        let categoryTh = influencerHelper.getCategories('th')
        let categoryVn = influencerHelper.getCategories('vn')
        let categoryId = influencerHelper.getCategories('id')
        let categoryCn = influencerHelper.getCategories('cn')
        let catIdx = this.categories.findIndex(f => f === this.filters.category)
        this.filteredItems = this.filteredItems.filter(f => f.keywords.includes(this.filters.category) ||
          f.keywords.includes(categoryTh[catIdx]) ||
          f.keywords.includes(categoryVn[catIdx]) ||
          f.keywords.includes(categoryId[catIdx]) ||
          f.keywords.includes(categoryCn[catIdx])
        )
      }
      if (this.filters.followers.from) {
        let from = this.filters.followers.from.replace('K', '000').replace('M', '000000')
        this.filteredItems = this.filteredItems.filter(f => f.igFollowerCount >= Number(from))
      }
      if (this.filters.followers.to) {
        let to = this.filters.followers.to.replace('K', '000').replace('M', '000000')
        this.filteredItems = this.filteredItems.filter(f => f.igFollowerCount <= Number(to))
      }
      if (this.filters.tiktokFollowers.from) {
        let from = this.filters.tiktokFollowers.from.replace('K', '000').replace('M', '000000')
        this.filteredItems = this.filteredItems.filter(f => f.tiktokFollowerCount >= Number(from))
      }
      if (this.filters.tiktokFollowers.to) {
        let to = this.filters.tiktokFollowers.to.replace('K', '000').replace('M', '000000')
        this.filteredItems = this.filteredItems.filter(f => f.tiktokFollowerCount <= Number(to))
      }
      if (this.filters.isTikTokEmpty) {
        this.filteredItems = this.filteredItems.filter(f => !f.tiktokFollowerCount)
      }
      if (this.filters.isIgEmpty) {
        this.filteredItems = this.filteredItems.filter(f => !f.igFollowerCount)
      }
      if (this.filters.dateOfBirth) {
        this.filteredItems = this.filteredItems.filter(f => f.dateOfBirth && f.dateOfBirth.includes(this.filters.dateOfBirth))
      }
      if (this.filters.age.min || this.filters.age.max) {
        this.filteredItems = this.filteredItems.filter(f => {
          if (!f.dateOfBirth) return false
          const today = new Date()
          const birthDate = new Date(f.dateOfBirth)
          let age = today.getFullYear() - birthDate.getFullYear()
          const monthDiff = today.getMonth() - birthDate.getMonth()
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--
          }
          if (this.filters.age.min && age < Number(this.filters.age.min)) return false
          if (this.filters.age.max && age > Number(this.filters.age.max)) return false
          return true
        })
      }
      if (this.filters.starOnly) {
        this.filteredItems = this.filteredItems.filter(f => f.star)
      }
      if (this.filters.mainCategory) {
        this.filteredItems = this.filteredItems.filter(f => f.mainCategories && f.mainCategories.includes(this.filters.mainCategory))
      }
      if (this.filters.subCategory) {
        this.filteredItems = this.filteredItems.filter(f => f.subCategories && f.subCategories.includes(this.filters.subCategory))
      }
      if (this.filters.cc) {
        this.filteredItems = this.filteredItems.filter(f => f.sourceID === this.filters.cc)
      }
      // Filter by Status
      if (this.filters.status) {
        this.filteredItems = this.filteredItems.filter(f => {
          if (this.filters.status === 'Pending') {
            return f.verify === null || f.verify === undefined
          } else if (this.filters.status === 'Valid') {
            return f.verify === true
          } else if (this.filters.status === 'Invalid') {
            return f.verify === false
          }
          return true
        })
      }
      // Filter by Content Type and Rate
      if (this.filters.contentType) {
        let contentTypeValue = this.filters.contentType.value
        this.filteredItems = this.filteredItems.filter(f => {
          let rates = f.ordinaryRates || {}
          let rateValue = rates[contentTypeValue]
          if (!rateValue) return false
          
          // Filter by currency if selected
          if (this.filters.rateCurrency) {
            let currencyKey = contentTypeValue + 'Currency'
            if (rates[currencyKey] !== this.filters.rateCurrency) {
              return false
            }
          }
          
          // Filter by rate range
          if (this.filters.rate.from !== '' && this.filters.rate.from !== null) {
            if (Number(rateValue) < Number(this.filters.rate.from)) {
              return false
            }
          }
          if (this.filters.rate.to !== '' && this.filters.rate.to !== null) {
            if (Number(rateValue) > Number(this.filters.rate.to)) {
              return false
            }
          }
          
          return true
        })
      }
      
      
      // For Sortings
      let sortCol = this.sort.column
      let sortType = this.sort.type === 'Ascending' ? 'asc' : 'desc'
      this.filteredItems = this.filteredItems.map(f => {
        if (f.igFollowerCount) {
          f.igFollowerCount = Number(f.igFollowerCount)
        }
        if (f.tiktokFollowerCount) {
          f.tiktokFollowerCount = Number(f.tiktokFollowerCount)
        }
        let rates = f.ordinaryRates || {}
        if (rates.igStory) {
          f.igStory = Number(rates.igStory)
          f.igStoryCurrency = rates.igStoryCurrency
        }
        if (rates.igPost) {
          f.igPost = Number(rates.igPost)
          f.igPostCurrency = rates.igPostCurrency
        }
        if (rates.igCarousel) {
          f.igCarousel = Number(rates.igCarousel)
          f.igCarouselCurrency = rates.igCarouselCurrency
        }
        if (rates.igVideo) {
          f.igVideo = Number(rates.igVideo)
          f.igVideoCurrency = rates.igVideoCurrency
        }
        if (rates.igReel) {
          f.igReel = Number(rates.igReel)
          f.igReelCurrency = rates.igReelCurrency
        }
        if (rates.igTv) {
          f.igTv = Number(rates.igTv)
          f.igTvCurrency = rates.igTvCurrency
        }
        if (rates.loadingFee) {
          f.loadingFee = Number(rates.loadingFee)
          f.loadingFeeCurrency = rates.loadingFeeCurrency
        }
        if (rates.eventAppearance) {
          f.eventAppearance = Number(rates.eventAppearance)
          f.eventAppearanceCurrency = rates.eventAppearanceCurrency
        }
        if (rates.tiktok) {
          f.tiktok = Number(rates.tiktok)
          f.tiktokCurrency = rates.tiktokCurrency
        }
        return f
      })
      if (sortCol === 'IG followers') {
        this.filteredItems = this.filteredItems.filter(f => f.igFollowerCount)
        this.filteredItems = orderBy(this.filteredItems, ['igFollowerCount'], [sortType])
      }
      if (sortCol === 'TikTok followers') {
        this.filteredItems = this.filteredItems.filter(f => f.tiktokFollowerCount)
        this.filteredItems = orderBy(this.filteredItems, ['tiktokFollowerCount'], [sortType])
      }
      if (sortCol === 'Date of Birth') {
        this.filteredItems = this.filteredItems.filter(f => f.dateOfBirth)
        this.filteredItems = orderBy(this.filteredItems, ['dateOfBirth'], [sortType])
      }
      if (sortCol === 'Last Updated') {
        this.filteredItems = orderBy(this.filteredItems, ['updatedAt'], [sortType])
      }
      if (sortCol === 'IG Story') {
        this.filteredItems = this.filteredItems.filter(f => f.igStory)
        this.filteredItems = orderBy(this.filteredItems, ['igStory'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.igStoryCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'IG Post') {
        this.filteredItems = this.filteredItems.filter(f => f.igPost)
        this.filteredItems = orderBy(this.filteredItems, ['igPost'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.igPostCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'IG Carousel') {
        this.filteredItems = this.filteredItems.filter(f => f.igCarousel)
        this.filteredItems = orderBy(this.filteredItems, ['igCarousel'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.igCarouselCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'IG Reel') {
        this.filteredItems = this.filteredItems.filter(f => f.igReel)
        this.filteredItems = orderBy(this.filteredItems, ['igReel'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.igReelCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'Loading Fee') {
        this.filteredItems = this.filteredItems.filter(f => f.loadingFee)
        this.filteredItems = orderBy(this.filteredItems, ['loadingFee'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.loadingFeeCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'Event Attendance') {
        this.filteredItems = this.filteredItems.filter(f => f.eventAppearance)
        this.filteredItems = orderBy(this.filteredItems, ['eventAppearance'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.eventAppearanceCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'TikTok') {
        this.filteredItems = this.filteredItems.filter(f => f.tiktok)
        this.filteredItems = orderBy(this.filteredItems, ['tiktok'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.tiktokCurrency === this.sort.currency)
        }
      }

      // Calculate total values based on verify field
      this.totalValues.pending = this.filteredItems.filter(f => f.verify === null || f.verify === undefined).length
      this.totalValues.verified = this.filteredItems.filter(f => f.verify === true).length
      this.totalValues.unverified = this.filteredItems.filter(f => f.verify === false).length
    },
    formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>')
      }
      return text
    },
    openResetDialog(item) {
      if (!item.email) {
        this.$swal({
          title: 'Empty Email',
          text: 'Please update email to reset password.',
          type: 'warning'
        })
        return
      }
      this.viewData = item
      // this.selectedInfluencerID = item.id
      this.infPassResetDialog = true
    },
    async deleteRateCard(id) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true;
          let payload = Object.assign({}, {
            id
          })
          await this.$store.dispatch('influencer/deleteCreatorCommunity', payload)
          this.isLoading = false;
          if (!this.savedCreatorCommunity) {
            this.$swal({
              text: 'Error Deleting Rate Card.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully deleted.',
            type: 'success'
          });
          await this.getRateCardLists()
          this.searchFilter()
        }
      });
    },
    async chgStarStatus(item, status) {
      this.isLoading = true
      let data = [
        {
          id: item.id,
          star: status
        }
      ]
      // Submit request to save star data
      await this.$store.dispatch('influencer/updateCreatorCommunityByIds', data)
      this.isLoading = false
      if (this.savedCreatorCommunity) {
        let matchIdx = this.filteredItems.findIndex(f => f.id === item.id)
        this.filteredItems[matchIdx].star = status
        this.filteredItems = Object.assign([], this.filteredItems)
      }
    },
    resetFilters() {
      this.filters = {
        country: '',
        category: '',
        mainCategory: '',
        subCategory: '',
        cc: '',
        followers: {from: '', to: ''},
        tiktokFollowers: {from: '', to: ''},
        contentType: '',
        rateCurrency: '',
        rate: {from: '', to: ''},
        age: {min: '', max: ''},
        isTikTokEmpty: false,
        isIgEmpty: false,
        starOnly: false
      }
    },
    cancelDOB() {
      this.dateOfBirthCal = false
      this.searchFilter()
    },
    searchIGFollower() {
      this.sort.column = 'IG followers'
      this.sort.type = 'Descending'
      this.searchFilter()
    },
    searchTikTokFollower() {
      this.sort.column = 'TikTok followers'
      this.sort.type = 'Descending'
      this.searchFilter()
    },
    async changeLabel(item) {
      this.isLoading = true
      let data = [
        {
          id: item.id,
          mainCategories: item.mainCategories,
          subCategories: item.subCategories
        }
      ]
      // Submit request to save star data
      await this.$store.dispatch('influencer/updateCreatorCommunityByIds', data)
      this.isLoading = false
      if (this.savedCreatorCommunity) {
        this.filteredItems = Object.assign([], this.filteredItems)
      }
    },
    async onBoardSuccess() {
      let data = [
        {
          id: this.viewData.id,
          accountExist: true
        }
      ]
      // Submit request to save star data
      await this.$store.dispatch('influencer/updateCreatorCommunityByIds', data)
      this.getRateCardLists()
    },
    openVerifyDialog(item) {
      this.verifyData = item
      this.verifyDialog = true
    },
    async handleVerified() {
      await this.getRateCardLists()
    }
  }
}
</script>
<style>
  #rate-card-data-table tbody tr td {
    min-width: 100px!important;
  }
  #rate-card-data-table tbody td .remark-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?ef98e556